import React, { Component } from 'react';
import { connect } from 'react-redux';
import { css } from 'react-emotion';
import { components, colors } from '@peachjar/components';
import gql from 'graphql-tag';
import _ from 'lodash';
import { Query } from 'react-apollo';
import EnhancedTable from '../components/EnhancedTable';
import {
  setVerifiedSchools,
  setVerifiedDistrict,
  sendVerifiedSchools,
  setTabViewSetupSchool,
} from '../setup-school.duck';

const {
  Buttons: { ButtonPrimaryLarge },
  Notifications: { notifyError, notifyWarn, PermanentNotification },
} = components;
const { mercury } = colors;

const LOOKUP_NCES_DISTRICT_QUERY = gql`
  query lookupNcesDistrict($ncesId: String!, $registrationId: ID!) {
    lookupNcesDistrict(partialId: $ncesId) {
      id
      name
      street
      city
      state
      zipcode
      schools {
        id
        name
        address
        street
        city
        state
        zipcode
        latitude
        longitude
        enrollment
        grades
        level
      }
    }
    schoolOrDistrictRegistration(id: $registrationId) {
      id
      schoolSelections
    }
  }
`;
class ReviewSchools extends Component {
  state = {
    order: 'desc',
    orderBy: 'name',
    selected: [],
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelected = (event, school) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(school);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, school);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected }, () =>
      this.props.handleVerifiedSchools(newSelected)
    );
  };

  handleSelectedLock = schools => {
    this.setState({ selected: schools }, () =>
      this.props.handleVerifiedSchools(schools)
    );
  };

  getSelectedSchools = (data) => {
    if (_.get(data, 'schoolOrDistrictRegistration.schoolSelections.length', 0) > 0) {
      const registrationSelections = data.schoolOrDistrictRegistration.schoolSelections;
      return data.lookupNcesDistrict[0].schools.filter(({id}) => registrationSelections.includes(id));
    }
    if (this.state.selected && this.state.selected.length > 0)
      return this.state.selected;
    if (this.props.previouslyVerifiedSchools && this.props.previouslyVerifiedSchools.length > 0)
      return this.props.previouslyVerifiedSchools;
    return [];
  };

  render() {
    const { ncesDistrictId, numberOfSchools, areSchoolsActivated, registrationId, previouslyVerifiedSchools } = this.props;
    const queryVariables = { ncesId: ncesDistrictId, registrationId };
    const READ_ONLY_MESSAGE =
      'Your school list has already been uploaded. You will be able to make updates once the setup process has been completed.';

    return (
      <div
        style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '3px',
        }}
      >
        <React.Fragment>
          <div style={{ padding: '1rem' }}>
            <Query
              query={LOOKUP_NCES_DISTRICT_QUERY}
              variables={queryVariables}
            >
              {({ loading, error, data = {} }) => {
                if (loading) return <noscript />;
                if (error) {
                  return <div>Error</div>;
                }

                const schoolData = _.orderBy(
                  data.lookupNcesDistrict[0].schools,
                  [this.state.orderBy],
                  [this.state.order]
                );

                const selectedSchools = this.getSelectedSchools(data);

                // Shaping district data for post request and dispatch to Redux
                const district = data.lookupNcesDistrict[0];
                const districtData = {
                  id: district.id,
                  name: district.name,
                  street: district.street,
                  city: district.city,
                  state: district.state,
                  zipcode: district.zipcode,
                };
                this.props.handleVerifiedSchoolsDistrict(districtData);

                const schoolsQueriedCount = schoolData.length;

                return (
                  <EnhancedTable
                    data={schoolData}
                    areSchoolsActivated={areSchoolsActivated}
                    order={this.state.order}
                    selected={selectedSchools}
                    orderBy={this.state.orderBy}
                    handleRequestSort={this.handleRequestSort}
                    handleSelected={this.handleSelected}
                    checkboxLock={areSchoolsActivated}
                    handleSelectedLock={this.handleSelectedLock}
                    notifyError={this.props.notifyError}
                    notifyWarn={this.props.notifyWarn}
                    handleSchoolSelectionError={
                      this.props.handleSchoolSelectionError
                    }
                  />
                );
              }}
            </Query>
          </div>
        </React.Fragment>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '1rem',
            marginRight: '1rem',
          }}
        >
          <ButtonPrimaryLarge
            disabled={this.state.selected.length <= 0 && !areSchoolsActivated}
            onClick={() => this.props.handleContinue(areSchoolsActivated)}
          >
            Continue
          </ButtonPrimaryLarge>
        </div>
        <PermanentNotification
          messageLabel="Note"
          message="If you need to make edits to your school list, please contact us at (858) 997-2117."
          backgroundColor={mercury}
          classNames={css`
            height: 63px;
            margin-top: 1.5rem !important;
            margin-right: 1rem !important;
            margin-left: 1rem !important;
          `}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  handleVerifiedSchools: schools => {
    dispatch(setVerifiedSchools(schools));
  },
  handleVerifiedSchoolsDistrict: districtData => {
    dispatch(setVerifiedDistrict(districtData));
  },
  handleContinue: areSchoolsActivated => {
    if (!areSchoolsActivated) {
      dispatch(sendVerifiedSchools());
    }
    dispatch(setTabViewSetupSchool(2));
  },
  notifyError: message => {
    dispatch(notifyError(message));
  },
  notifyWarn: message => {
    dispatch(notifyWarn(message));
  },
});

const mapStateToProps = state => ({
  registrationId: state.user.registrationId,
  previouslyVerifiedSchools: _.get(state, 'setupSchool.verifiedSchools', []),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewSchools);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/containers/ReviewSchoolsTab.jsx